<template>
  <div class="navbar">
    <div class="userinfo" v-if="!isCollapse" :style="'height:' + headerH + 'px;width:' + widthimg + 'px;'">
      <img :src="imgUrl(Logourl)" alt="">
      <!-- <div class="userinfo_name" v-if="userinfo">
        <img :src="imgUrl(userinfo.avatar)" alt="">
        {{ userinfo.username }}
      </div> -->
    </div>
    <el-menu :default-active="routeractive" class="el-menu-vertical-demo" @select="handleSelect" unique-opened
      :router="true" :collapse="isCollapse" background-color="#fff" active-background-color="#2B88FF">
      <el-menu-item index="home">
        <i class="el-icon-s-home"></i>
        <span>首页</span>
      </el-menu-item>
      <el-submenu index="agentManage">
        <template slot="title">
          <i class="el-icon-s-check"></i>
          <span>客户管理</span>
        </template>
        <el-menu-item index="agent">客户服务</el-menu-item>
        <el-menu-item index="userinfo">零售客户</el-menu-item>

      </el-submenu>


      <el-submenu index="userinfo123">
        <template slot="title">
          <i class="el-icon-s-operation"></i>
          <span>合同管理</span>
        </template>
        <el-menu-item index="agentcontract">合同签订</el-menu-item>
        <!-- <el-menu-item index="EASurvey">用电评估调查</el-menu-item> -->
        <el-menu-item index="ESContract">代理人合同</el-menu-item>
      </el-submenu>
      <!-- <el-submenu index="FillInTheBill">
        <template slot="title">
          <i class="el-icon-s-opportunity"></i>
          <span>电费账单管理</span>
        </template>
        <el-menu-item index="FillInTheBill">填报账单(手动)</el-menu-item>
        <el-menu-item index="Billinquiry">账单查询(手动)</el-menu-item>

      </el-submenu> -->
      <!-- <el-submenu index="monthImport">
        <template slot="title">
          <i class="el-icon-s-management"></i>
          <span>结算单管理</span>
        </template>
        <el-menu-item index="monthImport">按月份导入</el-menu-item>
        <el-menu-item index="JSDImport">结算单导入矫正</el-menu-item>
        <el-menu-item index="cooperateJSD">合作伙伴结算单</el-menu-item>
        <el-menu-item index="comprehensiveJSD">综合一张表结算单</el-menu-item>
      </el-submenu> -->
      <el-submenu index="everydaydldfimp">
        <template slot="title">
          <i class="el-icon-s-data"></i>
          <span>报价管理</span>
        </template>
        <!-- <el-menu-item index="everydaydldfimp">每日电量电费</el-menu-item> -->
        <el-menu-item index="quotationsetting">报价设定</el-menu-item>
        <el-menu-item index="everydaydllsk">历史报价</el-menu-item>
        <!-- <el-menu-item index="jzycjy">矫正预测交易</el-menu-item> -->
        <!-- <el-menu-item index="monthydltj">本月用电量统计</el-menu-item> -->
        <!-- <el-menu-item index="totalDj">总电量</el-menu-item> -->
        <!-- <el-menu-item index="ycjyzjl">预测交易总电量</el-menu-item> -->

      </el-submenu>
      <el-submenu index="basicSettings">
        <template slot="title">
          <i class="el-icon-s-tools"></i>
          <span>信息管理</span>
        </template>
        <!-- <el-menu-item index="electricityMeter">电网输配电表价</el-menu-item> -->
        <el-menu-item index="fileInfo">文件信息</el-menu-item>
        <el-menu-item index="infoPush">信息报送</el-menu-item>
      </el-submenu>
    </el-menu>

  </div>
</template>

<script>
import { LogoApi } from '@/Api/login'
export default {
  name: "NavbarView",
  props: {
    widthimg: {
      type: Number,
      default: 0
    },
    headerH: {
      type: Number,
      default: 0
    },
    isCollapse: {
      type: Boolean,
      default: false
    },
    routeractive: {
      type: String,
      default: '/'
    },
    userinfo: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      Highlight: '',
      Logourl: ''
    };
  },
  created() {
    // this.userinfo = JSON.parse(localStorage.getItem("userinfo"));\
    this.getLogo()
  },
  // 监听路由改变积
  watch: {
    // $route(to, from) {
    //   this.routeractive = to.name;
    // }
    // headerH: {
    //   handler(val) {
    //     console.log(val);

    //     this.Highlight = val;
    //   },
    //   immediate: true,
    //   deep: true
    // }
  },
  methods: {
    // 获取Logo图
    async getLogo() {
      let res = await LogoApi()
      this.Logourl = res.data.logo
    },
    handleSelect(key, keyPath) {
      // console.log(key, keyPath);
      this.$emit('changeRouter', keyPath)
    },
  }
};
</script>

<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
}
</style>
<style lang="scss" scoped>
.navbar {
  &::v-deep .el-menu {
    border-right: none;

    .el-menu-item.is-active {
      background-color: #2b88ff !important;
      color: white !important;

      i {
        color: white;
      }
    }

    // 子菜单标题激活状态
    // .el-submenu__title .is-active {
    //   background-color: #2b88ff !important;
    //   color: white !important;

    //   i {
    //     color: white;
    //   }
    // }

    // 悬停状态样式（可选）
    .el-menu-item:hover,
    .el-submenu__title:hover {
      background-color: rgba(0, 0, 0, 0.1) !important;
      color: #333 !important;
    }

    .el-menu-item.is-active:hover {
      background-color: #2b88ff !important;
      color: white !important;

      i {
        color: white;
      }
    }
  }

  .userinfo {
    // padding: 20px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;

    img {
      width: 100%;
      height: 100%;
    }

    .userinfo_name {
      display: flex;
      align-items: center;
      font-weight: 400;
      font-size: 16px;
      color: #000000;

      img {
        margin-right: 12px;
        width: 48px;
        height: 48px;
        border-radius: 50%;
      }
    }
  }

}
</style>